import React from "react";
import { ImMail2 } from "react-icons/im";
import {
  ContactFormButton,
  ContactInputs,
  ContactLeft,
  ContactLeftTitle,
  ContactTextArea,
} from "./Contactform.elements";

function ContactForm() {
  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "5324d7ab-bdeb-4c14-a32e-809e8c0b1000");

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    }).then((res) => res.json());

    if (res.success) {
      console.log("Success", res);
      setResult(res.message);
    } else {
      console.log("Error", res);
      setResult(res.message);
    }
  };

  return (
    <ContactLeft>
      <ContactLeftTitle>
        <h2>Let Us Connect</h2>
        <ImMail2 />
      </ContactLeftTitle>
      <form onSubmit={onSubmit}>
        <ContactInputs
          type="text"
          name="name"
          placeholder="Your Name"
          required
        />
        <ContactInputs
          type="email"
          name="email"
          placeholder="Your Email"
          required
        />
        <ContactTextArea
          name="message"
          placeholder="Enter text here ..."
          required
        ></ContactTextArea>
        <ContactFormButton type="submit"> Send a message</ContactFormButton>
      </form>
      <span>{result}</span>
    </ContactLeft>
  );
}

export default ContactForm;
